export class ValidationMessageModel {
  public Type: string;
  public Message: string;
}
